import { render, staticRenderFns } from "./edit-serial.vue?vue&type=template&id=b1900966&scoped=true&"
import script from "./edit-serial.vue?vue&type=script&lang=js&"
export * from "./edit-serial.vue?vue&type=script&lang=js&"
import style0 from "./edit-serial.vue?vue&type=style&index=0&id=b1900966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1900966",
  null
  
)

export default component.exports